import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-icon-button',
  templateUrl: './icon-button.component.html',
  styleUrls: ['./icon-button.component.scss'],
})
export class IconButtonComponent {
  @Input() label: string = '';
  @Input() icon?: string;
  @Input() mode: 'subscribe' | 'upgrade' | 'normal' = 'normal';
  @Input() width: string | null = null;
  @Input() height: string | null = null;
  @Input() isUppercase?: boolean;
  @Input() customClass?: string;
  @Input() tabindex?: number;
  @Input() restrictFocus: boolean = false;
  @Input() padding: string | null = null;
  @Input() gap: string = '0.833vw';

  isHovered = false;
  isFocused = false;

  @Output() clicked = new EventEmitter<any>();
  @Output() focusIn = new EventEmitter<void>();
  @Output() focusOut = new EventEmitter<any>();

  onClick(event: any): void {
    this.clicked.emit(event);
  }

  focused(): void {
    this.isFocused = true;
    this.focusIn.emit();
  }

  focusedOut(evnt: FocusEvent): void {
    this.isFocused = false;
    this.focusOut.emit(evnt);
  }
}
